import { graphql } from '@api/generated';

import { getClient } from '../../../api/client';
import { ConversationsQuery } from '@api/generated/graphql';

const GET_CONVERSATIONS_QUERY = graphql(`
  query conversations($input: ConversationsInput!) {
    conversations(input: $input) {
      id
      sid
      queueIds
    }
  }
`);

export type PcsConversationType = ConversationsQuery['conversations'][0];

async function getPcsConversation(
  kazooCallId: string,
): Promise<PcsConversationType> {
  const { data, error } = await getClient().query({
    query: GET_CONVERSATIONS_QUERY,
    variables: {
      input: {
        kazooId: kazooCallId,
      },
    },
  });

  if (error) {
    throw new Error(error.message);
  }

  if (!data.conversations.length) {
    throw new Error('Conversation not found');
  }

  return data.conversations[0];
}

export default getPcsConversation;
